const AUTH_ERROR_HINTS = [
  {
    match: "Token is invalid, expired, or already used",
    hint: "This link or code is no longer valid. Please request a new one.",
  },
  {
    match: "Invalid token purpose",
    hint: "This action could not be completed. Please sign in again.",
  },
  {
    match: "Session invalid. Please login again.",
    hint: "Your session is no longer valid. Please sign in again.",
  },
  {
    match: "Refresh token is invalid, expired, or revoked",
    hint: "Your session has expired. Please sign in again.",
  },
  {
    match: "Verification code and challenge token are required",
    hint: "Enter the verification code from your authenticator app.",
  },
  {
    match: "This account uses Microsoft SSO. Please login with SSO.",
    hint: "This account signs in with Microsoft. Use Continue with Microsoft.",
  },
];

export function mapAuthErrorMessage(serverMessage, fallback) {
  if (!serverMessage || typeof serverMessage !== "string") {
    return fallback;
  }
  const row = AUTH_ERROR_HINTS.find(
    (r) =>
      serverMessage === r.match ||
      serverMessage.includes(r.match)
  );
  return row ? row.hint : serverMessage || fallback;
}

export function getServerErrorMessage(error) {
  return (
    error?.response?.data?.message ||
    error?.message ||
    null
  );
}
